import { Navigate, Outlet } from "react-router-dom";
import { SessionStorageData } from "../utils/helper";

function PublicRoute() {
    let isAuth = SessionStorageData();
    return !isAuth ? <Outlet /> : <Navigate to={{ pathname: "/dashboard" }} />;
}

export default PublicRoute;